// @core/api/endpoints/resource/get_resource_type.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ResourceTypeResponse,
} from '../../../types/resource';

const BASE_PATH = '/resource';

/**
 * Get resource type by name
 * Retrieves a resource type definition by its name. Returns the type's schema, display properties, and available relation types.
 */
export async function GetResourceType(
  type_name: string,
  options?: RequestOptions
): Promise<ResourceTypeResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/resources/types/:type_name`;
  requestPath = requestPath.replace(':type_name', encodeURIComponent(type_name));
  const requestOptions = options;
  return client.get<ResourceTypeResponse>(requestPath, { ...requestOptions });
}
